import React from 'react';
import { IoMdEye } from 'react-icons/io';
import { Container } from './styles';

import imgDefault from '~/assets/icons/image-default.svg';
import { KrClose } from '~/components/KoroIcons';
import formatDate from '~/utils/formatDate';
import { ICourtesyBatch } from '..';

interface ICard {
  courtesy: ICourtesyBatch;
  onViewTickets: (id: number) => void;
  onDeleteCourtesy: (id: number) => void;
}

const Card: React.FC<ICard> = ({
  courtesy,
  onViewTickets,
  onDeleteCourtesy,
}) => {
  const isGenerating = courtesy.status === 'Gerando';
  const isFailed = courtesy.status === 'Erro ao gerar';
  const isBlocked = isGenerating || isFailed;

  return (
    <Container className="d-flex bg-white justify-content-between align-items-center p-3 mt-3">
      <div className="w-5">
        <img
          src={courtesy.archive_url || imgDefault}
          alt={courtesy.event_name}
          className="default"
        />
      </div>
      <div className="w-5">
        <h3 className="mb-1">Cortesia</h3>
        <p className="mb-0">{courtesy.id}</p>
      </div>
      <div className="w-10">
        <h3 className="mb-1">Pedido</h3>
        <p className="mb-0">{courtesy.order_id}</p>
      </div>
      <div className="w-15">
        <h3 className="mb-1">Nome</h3>
        <p className="mb-0">{courtesy.name}</p>
      </div>
      <div className="w-5">
        <h3 className="mb-1">Data</h3>
        <p className="mb-0">{formatDate(courtesy.created_at, 'dd/MM/yyyy')}</p>
      </div>
      <div className="w-25">
        <h3 className="mb-1">Evento</h3>
        <p className="mb-0">
          <span className="fw-semibold">{courtesy.event_id}</span> -{' '}
          {courtesy.event_name}
        </p>
      </div>
      <div className="w-10">
        <h3 className="mb-1">Status</h3>
        <p className="mb-0">
          {isGenerating && (
            <span className="badge bg-warning text-dark">
              <span
                className="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              />
              Gerando...
            </span>
          )}
          {isFailed && <span className="badge bg-danger">Erro ao gerar</span>}
          {!isBlocked && courtesy.status}
        </p>
      </div>

      <div>
        <h3 className="mb-1">Total</h3>
        <p className="mb-0">{courtesy.quantity}</p>
      </div>

      <div>
        <h3 className="mb-1">Usados</h3>
        <p className="mb-0">{courtesy.used_quantity}</p>
      </div>

      <div className="d-flex align-items-center">
        <button
          type="button"
          className="btn-icons border-0 bg-transparent"
          onClick={() => onViewTickets(courtesy.id)}
          disabled={isBlocked}
          title="Ver Inscrições"
        >
          <div className="bg-orange rounded-circle d-flex align-items-center justify-content-center btn-eye-container">
            <IoMdEye size={20} color="#fff" />
          </div>
        </button>
        <button
          type="button"
          disabled={
            isBlocked ||
            courtesy.status === 'Encerrado' ||
            courtesy.used_quantity === courtesy.quantity
          }
          className={` ms-2 border-0 position-relative bg-transparent`}
          onClick={() => onDeleteCourtesy(courtesy.id)}
        >
          <span className="bg-orange rounded-circle">
            <KrClose size={16} color="#fff" />
          </span>
        </button>
      </div>
    </Container>
  );
};

export default Card;
